import AlertBox from '~/app/assets/javascripts/components/alert_box';
import 'jquery-mask-plugin';

const $allowanceForm = $('.js-allowance-form');
const $cpfInput = $('.js-mkt-cpf-input');
const $phoneInput = $('.js-mkt-phone-input');
const $formFeedback = $('#js-mkt-participate-section__feedback');
const $formSubmitBtn = $('.js-mkt-participate-section-submit-btn');
const $menuItems = $('.js-mkt-header-items');
const $mktSections = $('.js-mkt-section');

function allowanceFormSubmit(e) {
  e.preventDefault();
  $formSubmitBtn.prop('disabled', true);
  $formFeedback.fadeOut();
  $formFeedback.html('');

  $.ajax({
    url: this.action,
    method: this.method,
    data: $allowanceForm.serialize(),
  }).done(() => {
    AlertBox.render('success', 'Parabéns! Você se inscreveu no Processo Seletivo Mesada Quero Bolsa, agora é só torcer!', $formFeedback);
  }).fail(() => {
    AlertBox.render('error', 'Ocorreu um Erro! Entre em contato com o nosso Whatsapp 0800 123 2222', $formFeedback);
  }).always(() => {
    $formFeedback.fadeIn();
    $formSubmitBtn.prop('disabled', false);
  });
}

$cpfInput.mask('000.000.000-00');
$phoneInput.mask('(00) 000000009');
$allowanceForm.on('submit', allowanceFormSubmit);

function dogScroll() {
  const headerHeight = 60;
  const currentTop = $(window).scrollTop() + headerHeight;

  $mktSections.each((index, section) => {
    const $section = $(section);
    const sectionTop = $section.offset().top;
    const sectionBottom = sectionTop + $section.innerHeight();

    if (currentTop >= sectionTop && currentTop <= sectionBottom) {
      const sectionId = $section.attr('id');
      const $menuItem = $menuItems.find(`a[href='#${sectionId}']`);
      $menuItem.addClass('mkt-header__item--active').siblings().removeClass('mkt-header__item--active');
    }
  });
}

$(window).on('scroll', dogScroll);
dogScroll();

$(document).on('click', 'a[href^="#js-mkt"]', function smoothScroll(e) {
  e.preventDefault();
  const paddingHeight = 30;

  $('html, body').animate({
    scrollTop: $(this.getAttribute('href')).offset().top - paddingHeight,
  }, 500);
});
